import { type LinkDestination, webPaths } from "@zplanem/web-paths"

/**
 * Map a typed destination to a concrete web route for `<Link to>`. For the
 * families web has real routes this equals the canonical path; `projectJournal`
 * has no dedicated web route (it's a section on project-detail) so it maps to the
 * project route + `#journal` anchor; `unknown` falls through to its raw path so
 * the authenticated NotFound catch-all renders. `external` is returned unchanged
 * (callers render a new-tab anchor and never feed it to `<Link>`). `searchHash`
 * is the original `?...#...` to carry through (empty string if none).
 */
export function destinationToWebPath(
	dest: LinkDestination,
	searchHash: string,
): string {
	switch (dest.kind) {
		case "myTickets":
			return webPaths.myTickets() + searchHash
		case "property":
			return webPaths.property(dest.id) + searchHash
		case "propertyProjects":
			return webPaths.propertyProjects(dest.id) + searchHash
		case "project":
			return webPaths.project(dest.propertyId, dest.projectId) + searchHash
		case "projectTasks":
			return webPaths.projectTasks(dest.propertyId, dest.projectId) + searchHash
		case "propertyJournal":
			return webPaths.propertyJournal(dest.id) + searchHash
		case "projectJournal":
			return `${webPaths.project(dest.propertyId, dest.projectId)}#journal`
		case "chat":
			// Chat opens on the property; the chat panel keys off the chatId.
			return webPaths.property(dest.propertyId) + searchHash
		case "ticket":
			return webPaths.ticket(dest.propertyId, dest.ticketId) + searchHash
		case "invitation":
			return webPaths.invitation(dest.token) + searchHash
		case "unknown":
			return dest.path + searchHash
		case "external":
			return dest.url
	}
}
